import { CostChangeSource, CostHistoryEntry, CostSnapshot } from '../../api/costHistoryApi';
import { formatCostUnit } from '../../Helpers/maintenanceCostUtils';
import { ORDERED_CARDINAL_DIRECTIONS } from '../../Helpers/componentSortUtils';
import { translate } from '../../types/EnumTranslations';

const numberFormat = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 2 });

export const formatCostValue = (cost: number, unit: CostSnapshot['unit']): string =>
    `${numberFormat.format(cost)} ${formatCostUnit(unit)}`;

/** One line of a change: what changed, old value, new value. */
export interface CostChangeLine {
    label: string;
    from: string;
    to: string;
}

/**
 * The lines an entry shows: the base cost always (it carries the unit), then each
 * direction whose own replacement cost differs. "Standard" = the direction has none.
 */
export const costChangeLines = (entry: CostHistoryEntry): CostChangeLine[] => {
    const { from, to } = entry;
    const lines: CostChangeLine[] = [{
        label: 'Kostnad',
        from: formatCostValue(from.cost, from.unit),
        to: formatCostValue(to.cost, to.unit)
    }];
    for (const direction of ORDERED_CARDINAL_DIRECTIONS) {
        const before = from.directions?.[direction];
        const after = to.directions?.[direction];
        if (before === after) continue;
        lines.push({
            label: translate(direction),
            from: before === undefined ? 'Standard' : formatCostValue(before, from.unit),
            to: after === undefined ? 'Standard' : formatCostValue(after, to.unit)
        });
    }
    return lines;
};

export const costChangeSourceLabel = (source: CostChangeSource, buildingName?: string): string => {
    switch (source) {
        case 'draft':
            return buildingName ? `Underhållsplan – ${buildingName}` : 'Underhållsplan';
        case 'templatesEditor':
            return 'Underhållsmallar';
        case 'settings':
        default:
            return 'Inställningar';
    }
};
